import axios from 'axios';
import API_BASE_URL from '../config/api';
import authService from './authService';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const leadsService = {
  async getLeads(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.page) params.append('page', filters.page);
      if (filters.limit) params.append('limit', filters.limit);
      if (filters.status) params.append('status', filters.status);
      if (filters.customer_type) params.append('customer_type', filters.customer_type);
      if (filters.search) params.append('search', filters.search);
      
      const response = await api.get(`/leads?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch leads';
    }
  },

  async getLeadById(id) {
    try {
      const response = await api.get(`/leads/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch lead';
    }
  },

  async updateLead(id, data) {
    try {
      const response = await api.put(`/leads/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update lead';
    }
  },

  async deleteLead(id) {
    try {
      const response = await api.delete(`/leads/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete lead';
    }
  }
};

export default leadsService;
